import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `periodValueFormulaNode` is an abstract implementation of `wrapperFormulaNode`
 * representing a value for an account specification over a given period:
 * changeFormulaNode, openingBalanceFormulaNode, closingBalanceFormulaNode...
 *
 * @abstract
 */
export default class PeriodValueFormulaNode extends WrapperFormulaNode {
	accept(visitor) {
		return visitor.visitPeriodValueFormulaNode(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.valueType = "Amount";

		return properties;
	}
}
